import { generateColumnId } from '../../../utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { SALES_PERSON_VIDEO_REPORT_ID } from './salesPersonVideoReportId';

const defaultColumns = [
    FIELDS.SALES_PERSON.field,
    FIELDS.SPENT.field,
    FIELDS.COMPLETED_VIEWS.field,
    FIELDS.CPCV.field,
    FIELDS.CLICKS.field,
    FIELDS.CTR.field,
    FIELDS.CPA.field,
].map(field => generateColumnId(SALES_PERSON_VIDEO_REPORT_ID, field));

const customColumns = {
    [REPORT_PRESET.PERFORMANCE]: [
        FIELDS.SPENT.field,
        FIELDS.COMPLETED_VIEWS.field,
        FIELDS.IMPRESSIONS.field,
        FIELDS.VISIBLE_IMPRESSIONS.field,
        FIELDS.CPM.field,
        FIELDS.VCPM.field,
        FIELDS.CPCV.field,
        FIELDS.VIEWABILITY_RATE.field,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE.field,
        FIELDS.COMPLETION_RATE.field,
        FIELDS.CLICKS.field,
        FIELDS.CTR.field,
        FIELDS.VCTR.field,
        FIELDS.CPA.field,
        FIELDS.VIDEO_CVR.field,
        FIELDS.CONVERSIONS.field,
    ].map(field => generateColumnId(SALES_PERSON_VIDEO_REPORT_ID, field)),
};

export { defaultColumns, customColumns };
